import api from './api';
import avatarService from './avatar.service';
import TokenService from './token.service';

class AuthService {
  login(username, password) {
    return api
      .post('/auth/login', {
        username,
        password
      })
      .then((response) => {
        console.log(response);
        if (response.data.access_token) {
          TokenService.setUser(response.data);
          avatarService.fetch(response.data.avatar);
        } 
        return response.data;
      });
  }
  login_mfa(mfaCode, mfaStage1) {
    return api
      .post('/auth/login_mfa', {
        mfaCode,
        mfaStage1
      })
      .then((response) => {
        console.log(response);
        if (response.data.access_token) {
          TokenService.setUser(response.data);
          avatarService.fetch(response.data.avatar);
        } 
        return response.data;
      });
  }


  parent_authorization(token) {
    return api.post('/parent_authorization', {token});
  }
  
  forgotpassword(email) {
    return api.post('/auth/forgotpassword', {email});
  }
  
  forgotpassword2(token, new_password, new_password2) {
    return api.post('/auth/forgotpassword2', {token, new_password, new_password2});
  }
  changepassword(old_password, new_password, new_password2) {
    return api.post('/auth/changepassword', {old_password, new_password, new_password2});
  }
  logout() {
    return api.post('/auth/logout').then(() => {
      TokenService.removeUser();
      window.location.reload();
    });
  }

  is_signed_in() {
    return api.get('/auth/protected');
  }

  register(username, email, password) {
    return api.post('/auth/signup', {
      username,
      email,
      password
    });
  }
  
  mfa_status(password) {
    return api.post('/auth/mfa/status', {password});
  }
  
  mfa_activate(generated_code) {
    return api.post('/auth/mfa/activate', {generated_code});
  }
  mfa_deactivate(providedSecret) {
    return api.post('/auth/mfa/deactivate', {providedSecret});
  }

  getCurrentUser() {
    return TokenService.getUser();
  }
  
  getCurrentRole() {
    return TokenService.getUser().role;
  }

  isAdmin() {
    if(this.getCurrentUser() === null){
        return false;
    }
    return ['Admin', 'SuperAdmin'].includes(this.getCurrentUser().role);
  }
  isEmployee() {
    if(this.getCurrentUser() === null){
        return false;
    }
    return ['Admin', 'Coach', 'SuperAdmin', ].includes(this.getCurrentUser().role);
  }
  isEmployeeReferrerOrSpectator() {
    if(this.getCurrentUser() === null){
        return false;
    }
    return ['Spectator', 'Admin', 'Coach', 'SuperAdmin', 'Referrer'].includes(this.getCurrentUser().role);
  }

  isEmployeeOrSpectator() {
    if(this.getCurrentUser() === null){
        return false;
    }
    return ['Spectator', 'Admin', 'Coach', 'SuperAdmin'].includes(this.getCurrentUser().role);
  }
  
  isSpectator() {
    if(this.getCurrentUser() === null){
        return false;
    }
    return ['Spectator'].includes(this.getCurrentUser().role);
  }
  isStudent() {
    if(this.getCurrentUser() === null){
        return false;
    }
    return ['Student'].includes(this.getCurrentUser().role);
  }
  isSignedIn() {
    if(this.getCurrentUser() === null){
        return false;
    }
    return ['Student', 'Spectator', 'Referrer', 'Admin', 'Coach', 'SuperAdmin'].includes(this.getCurrentUser().role);
  }
  reauth() {
    return api.post(
              '/auth/refresh',
              {
                refreshToken: TokenService.getLocalRefreshToken()
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + TokenService.getLocalRefreshToken()
                }
              }
            )
            .then((res) => {
              if (res.status === 200) {
                TokenService.updateLocalAccessToken(res.data);
                return res
              }
            });
  }
}

export default new AuthService();
